export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const DELETE_REGISTRATION_SESSION = 'DELETE_REGISTRATION_SESSION';
export const FETCH_CALORIES_DATA = 'FETCH_CALORIES_DATA';
export const FETCH_TODAY_DATA = 'FETCH_TODAY_DATA';
export const SHOW_ALERT = 'SHOW_ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
